module.exports = __webpack_public_path__ + "img/In Game target_v2-124.95e9fa71.png";